import until from "./until.js"
import { ajax, uploadImg } from "./request.js"
import vue from 'vue'


//
function getRequestLang(type) {
  if (type === 'zh-cn') return 'zh-cn';
  else if (type === 'en') return 'en-us';
  else return 'zh-cn';
}

// var baseUrl =  until.environment()?'':'http://test.chathot.me/app/index.php?i=6&c=entry&m=new_star&'
// var baseUrl = process.env.NODE_ENV === 'development' ? '' : until.environment()?'https://api.management.chathot.me':'http://test.admin.chathot.me'; // 测试服
var baseUrl = process.env.NODE_ENV === 'development' ? '' : until.environment()?'https://api-manage.gamatops.com':'http://test-manage.gamatops.com'; // 测试服


function getRequestUrl(url) {
  const $store = vue.prototype.$selfGlobal.$globalStore;
  const $localStore = vue.prototype.$localStore;
  const getToken = $store.state.token || $localStore.get('token') || '';
  const getUid = $localStore.get('login_uid') || '';

  return baseUrl + url + `?lang=${getRequestLang(vue.prototype.$selfGlobal.$globalStore.state.locale)}&login_uid=${getUid}&token=${getToken}`;
}
//
export default {
  //国家管理 -- 热门国家列表
  getHotCountryList: function (data, method) {
    return ajax('post', getRequestUrl('/region/country/hotListByPage'), data, {
      method,
    });
  },
  //获取国家详情
  countryInfo: function (data, method) {
    return ajax('post', getRequestUrl('/api/Country/countryInfo'), data, {
      method,
    });
  },
  //金币发放管理列表
  sendCions_findMemberViolationByPage: function (data, method) {
    return ajax('post', getRequestUrl('/api/SendCoins/findMemberViolationByPage'), data, {
      method,
    });
  },
  //活动管理模块 -- 活动管理 -- 活动管理列表接口
  activity_actionDisplay: function (data, method) {
    return ajax('post', getRequestUrl('/activity/list'), data, {
      method,
    });
  },

  //活动管理模块 -- 活动管理 -- 视频管理
  getActVideoList: function (data, method) {
    return ajax('post', getRequestUrl('/activity/video/list'), data, {
      method,
    });
  },
  //活动管理模块 -- 活动管理 -- 视频管理保存
  saveActVideo: function (data, method) {
    return ajax('post', getRequestUrl('/activity/video/add'), data, {
      method,
    });
  },
  //活动管理模块 -- 活动管理 -- 视频管理删除
  deleteActVideo: function (data, method) {
    return ajax('post', getRequestUrl('/activity/video/del'), data, {
      method,
    });
  },

  //活动管理模块 -- 活动管理 -- 国家列表（弹窗select列表）
  activity_findCountryList: function (data, method) {
    return ajax('post', getRequestUrl('/api/Activity/findCountryList'), data, {
      method,
    });
  },
  //活动管理模块 -- 活动管理 -- 礼物类型列表（弹窗select列表）
  activity_findGiftList: function (data, method) {
    return ajax('post', getRequestUrl('/activity/findGiftList'), data, {
      method,
    });
  },
  //活动管理模块 -- 活动管理 -- 生日之星
  activity_birthList: function (data, method) {
    return ajax('post', getRequestUrl('/api/Activity/birthList'), data, {
      method,
    });
  },

  //活动管理模块 -- 活动管理 -- 生日之星
  activity_newBirthList: function (data, method) {
    return ajax('post', getRequestUrl('/api/Activity/newBirthList'), data, {
      method,
    });
  },

  //活动管理模块 -- 竞猜活动 -- 玩法信息
  playLawList: function (data, method) {
    return ajax('post', getRequestUrl('/api/Activity/guessRule'), data, {
      method,
    });
  },
  //活动管理模块 -- 竞猜活动 -- 创建/编辑活动
  createPlayLaw: function (data, method) {
    return ajax('post', getRequestUrl('/api/Activity/guessEdit'), data, {
      method,
    });
  },
  //活动管理模块 -- 竞猜活动 -- 下注详情
  betDetail: function (data, method) {
    return ajax('post', getRequestUrl('/api/Activity/guessBetDetail'), data, {
      method,
    });
  },
  //活动管理模块 -- 竞猜活动 -- 赞助者详情
  sponsorDetail: function (data, method) {
    return ajax('post', getRequestUrl('/api/Activity/guessSupportDetail'), data, {
      method,
    });
  },
  //活动管理模块 -- 竞猜活动 -- 队伍信息
  teamInfoList: function (data, method) {
    return ajax('post', getRequestUrl('/api/Activity/guessTeamInfo'), data, {
      method,
    });
  },
  //活动管理模块 -- 竞猜活动 -- 创建/编辑队伍信息
  createTeamInfo: function (data, method) {
    return ajax('post', getRequestUrl('/api/Activity/teamEdit'), data, {
      method,
    });
  },
  //活动管理模块 -- 竞猜活动 -- 队伍下注详情
  teamBetDetail: function (data, method) {
    return ajax('post', getRequestUrl('/api/Activity/guessBetLog'), data, {
      method,
    });
  },
  //活动管理模块 -- 竞猜活动 -- 录入赛果
  setWinResult: function (data, method) {
    return ajax('post', getRequestUrl('/api/Activity/guessWinData'), data, {
      method,
    });
  },


  //
}



// WEBPACK FOOTER //
// ./src/js/j-http.js